var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-content-block"},[_c('div',{staticClass:"checkout"},[_c('b-row',[_vm._l((_vm.checkout_blocks),function(block,key){return [(block.show)?_c(block.key,{key:_vm._uid+block+key,tag:"component",attrs:{"solution":_vm.solution}}):_vm._e()]})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }